import type { FaireProductEntity } from "../../entity_types/product";

export const p_n4r88kxegn: FaireProductEntity = {
  token: "p_n4r88kxegn",
  type: "product",
  name: "Mushroom People Magazine",
  brandToken: "b_cuur2wm6ik",
  brandName: "Broccoli",
  imageUrl: "https://cdn.faire.com/fastly/966a6c9b833b260b8e24292c10f16f4aedf6a3cf3eea1853fbb78bdcdf405670.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/035211faac095307bc485556420a06cf5eee2ee4849d53cd224c8ebd1c68839c.png",
    "https://cdn.faire.com/fastly/6a4da978f2abd8a9f9edbdee18ab92a9d7b987bc11d38f89cc91341c6ceeb520.png",
    "https://cdn.faire.com/fastly/3ed26d223ad29bc78a37bed54b7aa437b80d88c00caa7d0de50ba01d4710bffc.png",
    "https://cdn.faire.com/fastly/dfb996744ad54c34fb902145d63d7f8db6f3fe633d0cbf86172b00163a54bed7.png",
    "https://cdn.faire.com/fastly/e6108872cf73d7e3e6d7a94fd5ad0cef4818619a8607177511e22e9725ad7a50.png",
    "https://cdn.faire.com/fastly/e4022fbc74f80d3b908575b6fe8c86e4001964e54edbce643d7aa49dee340ae7.png",
    "https://cdn.faire.com/fastly/57b2d993160ccd1c2a03a1cb5adf601f650c7df54da22cc625d5cbbd315edb64.png"
  ],
  priceDollars: 14,
  description: "What is a mushroom? What do mushrooms mean? What do mushrooms do? What do we want from mushrooms? What do the mushrooms want?\n\nThese are the questions the makers of Broccoli ask and answer in Mushroom People, our special edition, magazine for mycophiles that will rival any coffee table book. We call on artists, writers, and fungi enthusiasts from around the world to explore mushroom fact and fantasy, collecting specimens of all kinds: the strange and familiar, beautiful and ugly, toxic and healing, ephemeral and enduring.\n\n• 192 pages, perfect bound, three premium paper stocks.\n• 8.25\" x 11.25\"",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:37.306Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
